<template>
  <div class="layout-padding" :class="{'modalpage':page==='exhibition'}">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="상품 조회"
      desc="등록한 상품들의 현황을 조회할 수 있습니다."
      ref="admin_filter"
    ></admin-filter>

    <div class="columns is-multiline" style="margin-bottom:0">
      <div class="column is-6 flex" v-if="tableItems.length > 0 && page!=='exhibition'" style="margin:12px 0">
        <button v-if="isInternalPlugin('product_file_upload')"
          class="button is-primary" style="background-color:red !important;margin-right:12px" @click="$modal.show('deleteProductAllModal')">상품 전체 삭제</button>
        <button class="button is-primary" style="margin-right:12px" @click="clickDelete">상품 일괄 삭제</button>
        <button class="button" @click="$modal.show('adaptCategoryModal')" style="width:132px;margin-right:12px">카테고리 일괄 적용</button>
        <button class="button" @click="showCopyProductModal" style="width:132px">선택 상품 복사</button>
      </div>

      <div class="column btn-group-justify-end" :class="{'is-6': tableItems.length > 0}" v-if="page!=='exhibition'">
        <product-info-excel-upload v-if="isInternalPlugin('product_file_upload')"></product-info-excel-upload>
        <product-multiple-image-upload v-if="isInternalPlugin('product_image_upload')"></product-multiple-image-upload>
        <button @click="$router.push('product/create')" class="button is-primary">상품 등록</button>
      </div>

      <!-- 기획전 상품 등록 버튼 -->
      <div class="column is-full btn-group-justify-end" v-else-if="page==='exhibition'">
        <button class="button is-primary" @click="clickRegShowcase">선택 상품 등록</button>
      </div>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1808"
                 @check="clickCheckBox"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <template v-slot:box-upper>
        <div class="box-upper" v-if="packages.length>1">
          <div class="tab-wrapper" style="gap:8px">
            <div v-for="(pack, idx) in [{kor_name:'전체', name:''}].concat(packages)" :key="`pack-${idx}`"
                 class="tab-item unselect"
                 :class="{'selected': selectedPackage === pack.name}"
                 @click="selectedPackage=pack.name">{{ pack.kor_name }}</div>
          </div>
        </div>
      </template>
      <div slot="checkspot" slot-scope="props">
        <lp-check-bool
          v-if="showcaseCheckArr[props.idx]!==undefined"
          :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
      </div>

      <!--<div slot="exhibition" slot-scope="props" v-if="page==='exhibition'" style="width: 80px">
        <lp-check-bool
          v-if="showcaseCheckArr[props.idx]!==undefined"
          :checkedVal.sync="showcaseCheckArr[props.idx].value"></lp-check-bool>
      </div>-->

      <div slot="category" slot-scope="props" style="white-space: pre-wrap">{{ props.item.category.replaceAll('>','\n > ') }}</div>

      <div slot="partner.name" slot-scope="props">
        <div v-if="props.item.is_super_visor">
          <span v-for="(partner, p_idx) in props.item.partner_list" :key="`partner-${p_idx}`">
            {{ partner }}<span v-if="p_idx<props.item.partner_list.length-1">,</span></span>
        </div>
        <div v-else>{{ props.item.partner?props.item.partner.name:'' }}</div>
      </div>

      <div slot="status" slot-scope="props">
        <span v-if="props.item.status">{{ props.item.status }}</span>
        <span v-else>-</span>
      </div>

      <div slot="first_img" slot-scope="props">
        <div style="display: inline-block; text-align: center"
             :style="thumbImgField(props.item.first_img)" v-if="props.item.first_img"></div>
      </div>

      <div slot="name" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <span @click="detailLink(props.item.id)">{{ props.item.name }}</span>
      </div>

      <div slot="package" slot-scope="props">
        <div>{{ convertPackName(props.item.package) }}</div>
      </div>

      <div slot="is_simple" slot-scope="props">
        <div v-if="props.item.is_simple">간편상품</div>
        <div v-else>일반상품</div>
      </div>

      <div slot="price" slot-scope="props">
        <div>{{ props.item.price.price | currency }}</div>
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickProd(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger" @click.stop.prevent="clickProd(props.item,'delete')">삭제</button>
      </div>
    </admin-table>
    <!-- 상품 전체 삭제 -->
    <modal name="deleteProductAllModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="삭제" :useTab="false">
          <div style="color:red">전체 상품 데이터 뿐 아니라, 후기, 문의, 주문 기록 등 상품과 연관된 전체 데이터가 삭제되며<br>
            삭제하신 뒤에는 복구 할 수 없습니다.</div>
          <div style="margin-top:20px">전체 삭제를 진행하시겠습니까?</div>
          <div class="btn-group-justify-end">
            <button class="button is-light" @click="$modal.hide('deleteProductAllModal')">취소</button>
            <button class="button is-primary" @click="deleteProductAll">전체 삭제</button>
          </div>
        </admin-box-item>
      </div>
    </modal>

    <!-- 상품 일괄 삭제 -->
    <modal name="deleteProductsModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="삭제" :useTab="false">
          <div>선택하신 {{ getIdList().length }}개의 상품을 삭제하시겠습니까?</div>
          <div class="btn-group-justify-end">
            <button class="button is-light" @click="$modal.hide('deleteProductsModal')">취소</button>
            <button class="button is-primary" @click="deleteProducts">확인</button>
          </div>
        </admin-box-item>
      </div>
    </modal>

    <!-- 선택 상품 복사 -->
    <modal name="copyProductModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="상품 복사" :useTab="false">
          <div>선택하신 {{ getIdList().length }}개의 상품을 복사하시겠습니까?</div>
          <div class="btn-group-justify-end">
            <button class="button is-light" @click="$modal.hide('copyProductModal')">취소</button>
            <button class="button is-primary" @click="copyProduct">확인</button>
          </div>
        </admin-box-item>
      </div>
    </modal>

    <!-- 카테고리 일괄 적용 -->
    <modal name="adaptCategoryModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-box-item title="카테고리 일괄 적용"
                        :useTab="false"
                        subtitle="*선택한 카테고리에 따른 세부설정은 상품 상세에서 설정을 하셔야 합니다.
                        ex) 선택한 카테고리의 상품종류가 아웃링크일 경우, 링크 설정은 상세에서 직접해야합니다.">
          <div class="columns is-multiline">
            <div class="column is-full" style="height: 300px">
              <lp-adm-drop-input ref="adminput_prod"
                                 :data.sync="catArr1"
                                 :selectVal="selectedCategory(prod.category1_id, 'cat1')"
                                 @onSelect="res => clickCategory(res.value, 'cat1')"
                                 placeholder="1차 카테고리"
                                 width="160px"
                                 listAlign="center"
                                 style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

              <lp-adm-drop-input ref="adminput_prod"
                                 :data.sync="cat2"
                                 :selectVal="selectedCategory(prod.category2_id, 'cat2')"
                                 @onSelect="res => clickCategory(res.value, 'cat2')"
                                 placeholder="2차 카테고리"
                                 width="160px"
                                 listAlign="center"
                                 style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

              <lp-adm-drop-input ref="adminput_prod"
                                 :data.sync="cat3"
                                 :selectVal="selectedCategory(prod.category3_id, 'cat3')"
                                 @onSelect="res => clickCategory(res.value, 'cat3')"
                                 placeholder="3차 카테고리"
                                 width="160px"
                                 listAlign="center"
                                 style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>

            </div>
          </div>
          <div class="btn-group-justify-end">
            <button class="button is-light" @click="$modal.hide('adaptCategoryModal')">취소</button>
            <button class="button is-primary" @click="adaptCategory">확인</button>
          </div>
        </admin-box-item>
      </div>
    </modal>
  </div>
</template>

<script>
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import LpCheckBool from '../../module/common/LpCheckBool'
  import LpModal from '../../module/common/LpModal.vue'
  import AdminFilter from "../../module/admin/AdminFilter";
  import AdminTable from "../../module/admin/AdminTable";
  import ListMixin from '@/mixins/ListMixin'
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import InputFile from "../../module/common/InputFile";
  import OldInputFile from "../../module/common/OldInputFile";
  import ProductInfoExcelUpload from "./component/ProductInfoExcelUpload";
  import ProductMultipleImageUpload from "./component/ProductMultipleImageUpload";

  export default {
    name: 'ProductList',
    layout:'Main',
    mixins: [
      ListMixin
    ],
    props: {
      page: {
        type: String
      },
      selectedItems: {
        type: Array,
        default: function () {
          return []
        }
      },
      pack: {
        type: String
      },
      partnerProd: {
        type: Object
      },
      coupon: {
        type: Boolean,
        default: false
      }
    },
    components: {
      ProductMultipleImageUpload,
      ProductInfoExcelUpload,
      OldInputFile,
      InputFile,
      LpAdmDropInput,
      AdminTable,
      AdminFilter, LpSortDropDown,
      LpInputText, LpRadio, LpModal,
      LpCheckBool
    },
    data () {
      return {
        selectedPackage: '',
        basic_package: '',
        modalProd: 0,
        prodStatus: [
          { label: '전체', value: 'all' },
          { label: '노출', value: 'visible' },
          { label: '비노출', value: 'invisible' },
        ],
        // 상품별 기획전 등록 여부 체크박스 Array (모든 상품)
        // { id: 상품id, value: 기획전 등록 여부 }
        showcaseCheckArr: [
         /* { id: 1235, value: false },
          { id: 57, value: false },
          { id: 4, value: false },
          { id: 13, value: false }*/
        ],
        prod: {
          category1_id:'',
          category2_id:'',
          category3_id:'',
          order_conversion_type: '',
          package: ''
        },
        catArr1: [],
        cat2: [],         //1차 카테고리 관련된 카테고리만
        cat3: [],         //2차 카테고리 관련된 카테고리만
        catArr2: [],
        catArr3: [],
        packages: [],
        selectedPack: 0,
        uploadFile: []
      }
    },
    created() {
      this.init();
    },
    watch: {
      selectedPackage(n) {
        if(n !== '') {
          this.filtered.package = n;
        } else {
          delete this.filtered.package;
        }
        this.getData();
      },
      'prod.category1_id'(n){
        this.cat2 = this.get_cat(this.catArr2, n);
      },
      'prod.category2_id'(n){
        this.cat3 = this.get_cat(this.catArr3, n)
      }
    },
    methods: {
      init () {
        this.getBasicPackage();
        let url = 'product?is_parent=true';
        if(this.partnerProd) {
          url += `&partner_id=${this.partnerProd.id}`;
        }
        if(this.$route.query.search_keyword) {
          url += `&search_keyword=${this.$route.query.search_keyword}`
          this.$nextTick(()=> {
            this.$refs.admin_filter.searchItem.search_keyword = this.$route.query.search_keyword;
          })
        }
        let query = undefined;
        // 기획전에서 상품 종류 선택하고 상품 검색을 했을 경우
        if(this.pack && this.page==='exhibition') {
          this.setValueFilter();
          query = {
            package: this.pack
          };
        }
        if(this.coupon) {
          query = {
            package_list: ['mart','delivery','booking','reservation'].toString()
          }
        }
        this.initializing('product', url, query);
        let packages = this.$store.getters.getPackages.filter(i => i.name !== 'space');
        if(this.page!=='exhibition') {
          //  마트팩이 포함되어있는 경우
          if(find(packages, 'name', 'mart')) {
            let is_super_visor_name = find(this.tableData, 'eng_name', 'super_visor_name');
            if(!is_super_visor_name) {
              for(let x=0; x<this.tableData.length; x++) {
                if(this.tableData[x].eng_name==='category') {
                  this.tableData.splice(x+1, 0, this.tableValue('super_visor_name', '슈퍼바이저', 120));
                }
              }
            }
          }
          else this.filtered.is_partner = false;

          if(this.isDelivery()) {
            this.filtered.is_partner = true;
            this.filtered.package = 'delivery';

            for(let i=0; i<this.tableData.length; i++) {
              if(this.tableData[i].eng_name==='partner.name') removeIndex(this.tableData,i);
            }
          }

          if(this.isLaunchpack) {
            this.tableData.splice(3, 1, this.tableValue('priority', '노출우선순위', 100));
            // 런치팩 파트너일 때, 테마마켓 > 웹앱템플릿 카테고리 고정
            if(!this.isAdmin) {
              this.filtered.cat1 = 58;
              this.filtered.cat2 = 61;
              this.filterData = this.filterData.filter(i => i.type !== 'category');
            }
          }

        }
        this.getCats();

        this.addField();
        if(this.$route.query.partner) {
          this.filtered.search_type = 'partner';
          this.filtered.search_keyword = this.$route.query.partner;
          this.$nextTick(()=>{
            this.$refs.admin_filter.searchItem.search_keyword = this.$route.query.partner;
            // document.getElementsByClassName("input lp-filter-input")[0].value = this.$route.query.partner;
          });
        }
      },
      getDataFromServer() {
        this.getData();
      },
      isDelivery() {
        return this.pack && this.pack === 'delivery';
      },
      // 체크박스 선택 관련 - 일괄 선택시 선택한 id list를 조합함
      getIdList(){
        return this.showcaseCheckArr.filter(i => i.value).map(i => i.id);
      },
      showCopyProductModal() {
        if(this.getIdList().length===0) {
          this.toast('상품을 선택해 주세요.');
        }
        else this.$modal.show('copyProductModal')
      },
      copyProduct () {
        let products = this.getIdList();
        if(products.length>0) {
          this.$store.commit('setLoading', true);
          this.$axios.post(this.getUrl('product/copy'), {
            checked: products
          }).then(res => {
            if(res.status===200) {
              this.$store.commit('setLoading', false);
              this.$modal.hide('copyProductModal');
              this.toast('복사가 완료되었습니다.')
              this.getData();
            }
          }).catch(error=>{
            this.$store.commit('setLoading', false);
            this.$modal.hide('copyProductModal');
            if (error.response) {
              this.toast(error.response.data.message);
            }
            else {
              this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
            }
          });
        }
      },
      // 상품 일괄 삭제
      clickDelete() {
        let id_list = this.getIdList();
        if(id_list.length===0) {
          this.toast('삭제할 상품을 선택해주세요.');
          return;
        }
        this.$modal.show('deleteProductsModal')
      },
      deleteProductAll() {
        this.$axios.delete(this.getUrl('product/delete/hard')).then(res=>{
          if(res.status===200) {
            this.toast('전체 상품이 삭제되었습니다.');
            this.$modal.hide('deleteProductAllModal');
            this.getData();
          }
        })
      },
      deleteProducts() {
        let id_list = this.getIdList();
        if(id_list.length===0) {
          this.toast('삭제할 상품을 선택해주세요.');
          return;
        }
        this.$axios.delete(this.getUrl('product/delete/multiple'), {
          data: {
            products: id_list
          }
        }).then(res=>{
          if(res.status===200) {
            this.toast('선택한 상품들이 삭제되었습니다.');
            this.$modal.hide('deleteProductsModal');
            this.getData();
          }
        })
      },
      // 카테고리 일괄 적용
      adaptCategory() {
        let id_list = this.getIdList();
        if(id_list.length===0) {
          this.toast('카테고리 일괄 적용할 상품을 선택해주세요.');
          return;
        }
        if(this.prod.category1_id==='') {
          this.toast('카테고리를 선택해주세요.');
          return;
        }
        let prod = this.cloneItem(this.prod);
        prod.package = this.packages[this.selectedPack];
        this.$axios.patch(this.getUrl('product/category/adapt/multiple'), {
          products: id_list,
          prod: prod
        }).then(res=>{
          if(res.status===200) {
            this.toast('카테고리 일괄 적용이 완료되었습니다.');
            this.$modal.hide('adaptCategoryModal');
            this.getData();
            this.prod = {
              category1_id:'',
              category2_id:'',
              category3_id:'',
              order_conversion_type: ''
            };
            this.selectedPack = 0;
          }
        })
      },
      isKey(eng_name) {
        return this.tableData.findIndex(i => i.eng_name === eng_name) > -1;
      },
      tableValue(eng, kor, width) {
        return {eng_name: eng, ko_name: kor, width: `${width}px`};
      },
      addField() {
        let packs = this.$store.getters.getPackages;
        // 커머스 인 경우 주문신청, 구매내역 추가
        let data = undefined;
        if (packs.indexOf('commerce') > -1) {
          if(!this.isKey('order_count')) {
            data = this.tableValue('order_count', '주문 수', 60);
          }

          if(!this.isKey('purchase_count')) {
            data = this.tableValue('purchase_count', '구매 완료 수', 120);
          }
        }
        // 전화연결 경우 전화연결 수 추가
        if(packs.indexOf('call') > -1 && !this.isKey('call_count')) {
          data = this.tableValue('call_count', '전화 연결 수', 120);
        }
        if(data) {
          this.tableData.splice(this.tableData.length-1, 0, data);
        }

        // 기획전
        if(this.page === 'exhibition') {
          if(this.tableData[0].eng_name !== 'checkspot') {
            this.tableData.splice(0, 0, this.tableValue('checkspot', '', 47));
          }

          for(let i=0; i<this.tableData.length; i++){
            if(this.tableData[i].eng_name==='modify_delete') {
              this.tableData.splice(i, 1);
            }
          }
        }
        else {
          // modify_delete 키 유무에 따른 처리
          let is_key = false;
          for(let x=0; x<this.tableData.length; x++){
            if(this.tableData[x].eng_name === 'exhibition') {
              this.tableData.splice(x, 1);
            }
            else if(this.tableData[x].eng_name === 'modify_delete'){
              is_key = true;
              break;
            }
          }
          if (!is_key) {
            this.tableData.push(this.tableValue('modify_delete', '수정/삭제', '125px'));
          }

          if(this.tableData[0].eng_name !== 'checkspot') {
            this.tableData.splice(0, 0, this.tableValue('checkspot', '', 47));
          }
        }
      },
      detailLink(id) {
        let path = `product/create?id=${id}`;
        if(this.isDelivery()) path = `delivery/product/create?id=${id}`;
        this.$router.push(this.getPath(path));
      },
      clickProd(item, kind) {
        if(kind === 'update') {
          let path = 'product/create?id='+item.id;
          if(this.isDelivery()) path = `delivery/product/create?id=${item.id}`;
          this.$router.push(this.getPath(path));
        } else if(kind === 'delete') {

          let value = {
            id: item.id,
            url: 'product/',
            title: '상품을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
      delProduct() {
        this.$axios.delete(this.getUrl('product/')+this.modalProd)
          .then(res => {
            if (res.status===200) {
              this.$refs.deleteModal.close();
              this.toast('상품이 삭제되었습니다.');
              this.getData();
            }
          });
      },
      getProduct() {
        this.$axios.get(this.getUrl('product?is_parent=true'), {
          params: this.filtered
        })
          .then(res => {
            if (res.status === 200) {
              this.showcaseCheckArr = res.data.data.map(i => {
                return {
                  id: i.id,
                  value: false
                }
              });

              // 기획전, 게시물에서 모달로 상품을 띄울 경우 선택된 상품이 있으면 체크 표시
              if(this.selectedItems && this.selectedItems.length>0) {
                this.showcaseCheckArr.forEach(item=>{
                  if(this.selectedItems.includes(item.id)){
                    item.value = true;
                  }
                })
              }
            }
          });
      },
      // 상품문의 & 상품후기 상품 등록
      clickReg(item) {
        let id = item.id;
        this.$emit('getProduct', id);
      },
      // 기획전 상품 등록
      clickRegShowcase() {
        let id_list = this.getIdList();
        let productItems = this.tableItems.filter(i => id_list.indexOf(i.id)>-1);
        this.$emit('productItems', {
          productItems: productItems,
          id_list: id_list
        });
      },
      getCats(){
        // 카테고리 가져오기
        this.$axios.get(this.getUrl('category'))
          .then(res => {
            this.catArr1 = [];
            this.catArr2 = [];
            this.catArr3 = [];

            for (let cat of res.data) {
              // 1차 카테고리 추가
              this.catArr1.push({value: cat.id, label: cat.name, packages: cat.packages});

              for (let cat2 of cat.child) {
                // 2차 카테고리 추가
                this.catArr2.push({parent: cat.id, value: cat2.id, label: cat2.name});

                for (let cat3 of cat2.child) {
                  // 3차 카테고리 추가
                  this.catArr3.push({parent: cat2.id, value: cat3.id, label: cat3.name});
                }
              }
            }
            this.getPackages();
            this.cat2 = this.get_cat(this.catArr2, this.prod.category1_id);
            this.cat3 = this.get_cat(this.catArr3, this.prod.category2_id);
          });
      },
      selectedCategory(cat_id, type) {
        if(type === 'cat1') {
          type = 'catArr1';
        }
        let result = this[type].find(i => i.value === cat_id);
        return result ? result.label : undefined;
      },
      getBasicPackage() {
        /*this.$axios.get('public/service/basic/package').then(res=>{
          if(res.status===200) this.basic_package = res.data;
        })*/
        this.basic_package = this.$store.getters.getServiceSettingProduct.basic_package;
      },
      clickCategory(value, type) {
        if (type === 'cat1') {
          this.prod.category1_id = value;
          this.prod.category2_id = '';
          this.prod.category3_id = '';

          // 카테고리 1번 클릭할때마다 선택된 패키지 초기화
          let selectedPack = undefined;
          this.catArr1.forEach(item=>{
            if(item.value===value && item.packages.length>0) {
              item.packages.forEach(pack => {
                // 서비스 기본 선택된 팩이 카테고리의 상품 종류에 있을 경우
                if(pack === 'all') {
                  selectedPack = this.packages.find(i => i.name === this.basic_package);
                } else {
                  selectedPack = this.basic_package && item.packages.indexOf(this.basic_package) > -1 ?
                                  this.packages.find(i => i.name === this.basic_package) :
                                  this.packages.find(i => i.name === pack);
                }
              });
            }
          })
          if(selectedPack) {
            this.selectedPack = selectedPack;
            this.prod.package = selectedPack.name;
          }

          // 선택된 팩에 따라 주문 전환 리스트 변경
          this.changeConversionList();
        }
        else if (type === 'cat2') {
          this.prod.category2_id = value;
          this.prod.category3_id = '';
        }
        else if (type === 'cat3') {
          this.prod.category3_id = value;
        }
      },
      // Store에 저장되있는 팩 목록 가져오기
      getPackages(){
        this.packages = this.$store.getters.getPackages.filter(i => i.name !== 'space');

        // 선택된 팩이 있을 경우 selectedPack에 integer로 선택된 값 넘겨주기
        if(this.prod.package) {
          let index = this.packages.findIndex(i => i.name === this.prod.package);
          if(index > -1) {
            this.selectPackage(index, 'selected');
          }
        }
      },
      // 팩목록과 비교해서 선택된 팩을 다시 저장
      selectPackage(idx, type){
        this.selectedPack = idx;
        // 커머스 일 경우 커머스 내 종류 호출하기 ( 다운로드 팩 또는 일반 배송상품 return 값은 string)

        // 타입 초기화
        if(type === 'select') {
          this.prod.inquiry_conversion_type = 0;
          this.prod.order_conversion_type = 0;
          this.prod.payment_type = 0;
        }
        /*if(this.integerToStringSelectedPack()==='commerce') {
          this.$axios.get('admin/service/commerce/package').then(res=> {
            this.commercePack = res.data;
          });
        }*/
        //this.getCats();
        this.changeConversionList();
      },
      // 선택된 팩 string으로 반환 ( ex) commerce )
      integerToStringSelectedPack() {
        return this.packages[this.selectedPack];
      },
      // 주문 전환 목록
      changeConversionList() {
        this.prod.order_conversion_type = this.selectedPack.id;
      },
      clickUpload() {
        let params = {
          file: this.uploadFile[0]
        };
        this.$axios.post('admin/product/xlsx', params).then(res=> {
          this.toast('파일 업로드 되었습니다. 상품 등록이 완료되면 메일로 안내해드리겠습니다.');
          this.$modal.hide('uploadModal');
          this.onCloseUpload();
        });
      },
      clickDownload() {
        this.$axios.get('admin/product/xlsx').then(res => {
          location.href=res.data.file;
        });
      },
      onCloseUpload() {
        this.uploadFile = [];
      },
      // pack이 있을 경우 필터링값 추가
      async setValueFilter() {
        if(this.pack) {
          await this.$nextTick(async ()=> {
            let items = this.$refs.admin_filter.itemItems;
            await items.forEach(item=> {
              if(item.key==='package') {
                item.value = this.pack;
              }
            })
          })
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .modalpage
    margin-top 50px
    padding: 1.25rem

</style>
<style lang="stylus">
  .box-upper
    padding 18px
    border-bottom 1px solid #eeeeee

    .tab-wrapper
      display flex
      align-items center
      gap 8px

      .tab-item
        border-radius 50px
        padding 6px 14px
        border 1px solid #dddddd
        background-color white
        color #363636
        text-align center
        font-size 14px
        line-height 22px
      .selected
        background-color #363636
        border 1px solid #363636
        color white
</style>
